import axios from "axios"
import store from "@/store/index"
import CONSTANTS from "@/store/constants"
import QUESTIONNAIRE_MAP from "@/store/questionnaireMap";
import EXCEPTION_SUBMISSION_CONSTANTS from "@/store/exceptionSubmissionRequestFormConstants";

// Adding auth token to the adapters since v0.18.X + of axios supports adding auth tokens only after adapter creation not as defaults. 
const getInstanceWithHeaders = (baseURL) => {
    let axiosInstance = axios.create({baseURL: baseURL})
    if(baseURL == CONSTANTS.EMPLOYEE_HUB_SERVICE_NOW_API_BASE_URL)
    {
      axiosInstance.interceptors.request.use(
      config => {
          if (config.baseURL === baseURL && !config.headers.Authorization) {
              const token = store.getters.authResponse.idToken
              if (token) {
                  config.headers = {
                      Authorization: "Bearer " + store.getters.cognitoAccessToken,
                      "Accept": "*/*",
                      "Content-type": "application/json"
                  }
              }
          }
          return config;
      },
      error => Promise.reject(error)
      );
    }
    else{
      axiosInstance.interceptors.request.use(
      config => {
        if (config.baseURL === baseURL && !config.headers.Authorization) {
            const token = store.getters.authResponse.accessToken
            if (token) {
                config.headers = {
                    Authorization: "Bearer " + store.getters.authResponse.accessToken,
                }
            }
        }
        return config;
    },
    error => Promise.reject(error)
    );
    }
    return axiosInstance;
}

const employeeHubGuidesInstance =  getInstanceWithHeaders(CONSTANTS.EMPLOYEE_HUB_GUIDES_API_BASE_URL);
const employeeHubSupplierInstance = getInstanceWithHeaders(CONSTANTS.EMPLOYEE_HUB_SUPPLIER_API_BASE_URL);
const employeeHubInstance = getInstanceWithHeaders(CONSTANTS.EMPLOYEE_HUB_API_BASE_URL);
const headlessInstance = getInstanceWithHeaders(CONSTANTS.EMPLOYEE_HUB_HEADLESS_API_BASE_URL);
const enterpriseSearchInstance = getInstanceWithHeaders(CONSTANTS.ENTERPRISE_SEARCH_API_URL);
const serviceNowAxiosInstance = getInstanceWithHeaders(CONSTANTS.EMPLOYEE_HUB_SERVICE_NOW_API_BASE_URL);
const serverlessHubInstance = getInstanceWithHeaders(CONSTANTS.SERVERLESS_HUB_API_API_BASE_URL);
const ehUserManagementInstance = getInstanceWithHeaders(CONSTANTS.EMPLOYEE_HUB_USER_MANAGEMENT_BASE_URL);

const api = {
    getContentPage(alias) {
        return serverlessHubInstance.get("/cms/v1/pages/" + alias + "?type=Published");
    },
    getlandingSections() {
        let query =
            `{
              getAllAppRecords{
                id
                name
                jumpLink
                description
                displayType
                ehOrder
                subSection1Name
                subSection1Resources{
                  title
                  value
                }
                subSection2Name
                subSection2Resources{
                  title
                  value
                }
                subSection3Name
                subSection3Resources{
                  title
                  value
                }
              }
            }`
        return headlessInstance.post("/cmsapp/graphql?alias=supplier-central-landing-sections",
            {query});
    },
    getlandingSectionCards() {
        let query =
            `{
              getAllAppRecords{
                id
                name
                section
                description
                image
                ehOrder
                actionType
                actionLink
                searchTags
              }
            }`
        return headlessInstance.post("/cmsapp/graphql?alias=supplier-central-landing-cards",
            {query});
    },
    getLandingCardDecisionBranches() {
        let query =
            `{
              getAllAppRecords{
                id
                name
                category
                description
                card
                ehOrder
                actionType
                actionLink
                searchTags
                solutionContent
                subSectionName
                hideDescription
                subSectionResources{
                  title
                  value
                }
              }
            }`
        return headlessInstance.post("/cmsapp/graphql?alias=supplier-central-landing-decision-branches",
            {query});
    },
    getSearchResults(searchKeyword, esQuery, length) {
        let query = esQuery.replace("QUERY_TOBE_REPLACED", searchKeyword);
        query = length ? query.replace("ES_RESULTS_LENGTH", length) : query.replace("ES_RESULTS_LENGTH", 20);
        query = query.replace("`", "");
        query = "{" + query + "}"
        return enterpriseSearchInstance.post("", {query});
    },

    getVendorById(id) {
        let query =
            `{
          fetchVendorById(vendorId: "${id}") {
            id
            name
            website  
         }
  }`
        return employeeHubSupplierInstance.post("/supplier/graphql",
            {query});
    },
    getAllProducts() {
        let query =
            `{
      fetchAllProducts {
        id
        name
        status
        engagementUrl
        vendorId
        vendorName
      }
    }`
        return employeeHubSupplierInstance.post("/supplier/graphql",
            {query});
    },
    getAllVendors() {
        let query =
            `{
      fetchAllVendors {
        id
        name
        website
        supplierId
        status
      }
    }`
        return employeeHubSupplierInstance.post("/supplier/graphql",
            {query});
    },
    getUserDraftData() {
        let query =
            `{
      fetchSupplierOnBoardDraftRequest {
            id
            productDescription
            needHelpWithSupplier
            supplierName
            supplierWebsite
            productName
            businessJustification
            approximateSpend
            requestedBy
            requestedFor
            supplierContactRole
            supplierContactName
            supplierContactEmail
            supplierCountry
            personalDataProcessed
            integrateWithADSKNetwork
            integrateWithADSKProduct
            developAutodeskProductCode
            thirdPartyLicenseRequired
            cookieInstalledOnADSKNetwork
            purchaseType
            masterAgreementExists
            deliveredWithInYear
            serviceType
            service
            supplierLocated
            companyBuyingServices
            supplierLocatedInUSCanadaUK
            category
            updatedOn
            requestedStartDate
            supplierEmployeeCountBelowFive
            technologyFromReseller
            corporateCardPayment
            customerDataProcessed
            diverseSupplierConsidered
            recommendedByGovernment
            onBehalfOfAutodeskCustomer
            anyRelationshipWithAutodesk
            artificialIntelligenceOrMachineLearning
            customerIntellectualProperty
            softwareInstalledOnADSKMachine
            generativeAI 
            genAIAttestationSubmitted
            isPilotOrProofOfConcept
            duplicateForm
            resellerName
            }
        }`
        return employeeHubSupplierInstance.post("/supplier/graphql",
            {query});
    },
    fetchSupplierSubmissionStatusById(id) {
        let query =
            `{
                fetchWebformSubmissionStatusById(id: "${id}") {
                    formReferenceNumber
                    status
                    id
                    responseMessages
                    formType
                }
            }`
        return employeeHubSupplierInstance.post("/supplier/graphql",
            {query});
    },
    getInvoiceDraftRecords() {
        let query =
            `{
          fetchAllDraftWebformRequest {
            id
            updatedOn
            status
            poNumber
            supplierNumber
            supplierName
            supplierNameContinued
            companyCode
            companyCodeText
            currency
            invoiceDate
            invoicedAmount
            invoiceNumber
            formReferenceNumber
            paymentDueDate
            specialInstructions
            assignment
            docHeaderText
            paymentType
            paymentTypeDescription
            deliveryLocation
            invoiceReferenceForCreditMemo
            expenseType
            expenseTypeCode
            requesterEmail
            invoiceDescription
            directDebitDeductionDate
            payrollPaymentDate
            boletoSlipExpiryDate
            formType
            netAmount
            taxAmount
            totalAmount
            unmatchedAmount
            autoInputFlag
            creditMemo
            attachments {
              fileName
              fileId
              fileSize
            }
            invoiceItems {
              itemId
              itemDescription
              glAccount
              costCenter
              wbsElement
              itemTotal
            }
            attachmentUrl
            supplierTaxId
            city
            country
            houseNumber
            postalCode
            region
            street
          }
        }`
        return employeeHubSupplierInstance.post("/supplier/graphql",
            {query});
    },
    deleteDraftRequestById(id) {
        let query =
            `mutation{
              deleteDraftRecordById(id: "${id}")}
        `;
        return employeeHubSupplierInstance.post("/supplier/graphql",
            {query});
    },
    deleteInvoiceDraftRequestById(id) {
        let query =
            `mutation{
              deleteDraftWebformRequestById(id: "${id}")}
        `;
        return employeeHubSupplierInstance.post("/supplier/graphql",
            {query});
    },
    getAllOnBoardingRequestStatus() {
        let query =
            `{
                  fetchAllOnBoardingRequests {                 
                    id
                    productDescription
                    needHelpWithSupplier
                    supplierName
                    supplierWebsite
                    productName
                    businessJustification
                    requestedBy
                    requestedFor
                    supplierContactRole
                    supplierContactName
                    supplierContactEmail
                    supplierCountry
                    approximateSpend
                    personalDataProcessed
                    integrateWithADSKNetwork
                    integrateWithADSKProduct
                    developAutodeskProductCode
                    thirdPartyLicenseRequired
                    cookieInstalledOnADSKNetwork
                    purchaseType
                    masterAgreementExists
                    deliveredWithInYear
                    serviceType
                    service
                    supplierLocated
                    updatedOn
                    companyBuyingServices
                    supplierLocatedInUSCanadaUK
                    category
                    caseNumber
                    viewCaseUrl
                    createdOn
                    status
                    requestStatus
                    caseId
                    requestedStartDate
                    requestSubmissionType
                    supplierEmployeeCountBelowFive
                    diverseSupplierConsidered
                    technologyFromReseller
                    corporateCardPayment
                    customerDataProcessed
                    isRequestedForResubmission
                    recommendedByGovernment
                    onBehalfOfAutodeskCustomer
                    anyRelationshipWithAutodesk
                    artificialIntelligenceOrMachineLearning
                    customerIntellectualProperty
                    softwareInstalledOnADSKMachine
                    existingSupplier
                    serviceProduct
                    generativeAI 
                    genAIAttestationSubmitted
                    isPilotOrProofOfConcept
                    supplierApexStatus
                    inviteSent
                    duplicateForm
                    resellerName
                  }
            }`
        return employeeHubSupplierInstance.post("/supplier/graphql",
            {query});
    },
    fetchSupplierOnBoardDraftRequestById(id) {
        let query =
            `{
              fetchSupplierOnBoardDraftRequestById(id: "${id}"){
                attachments {
                    fileName
                    fileId
                    fileSize
                  }
                    watcherUserIds
              }
        }`;
        return employeeHubSupplierInstance.post("/supplier/graphql",
            {query});
    },
    fetchSupplierOnBoardRequestById(id) {
        let query =
            `{
              fetchSupplierOnBoardRequestById(id: "${id}"){
              attachments {
                    fileName
                    fileId
                    fileSize
                  }
                  watcherUserIds
              }  
        }`;
        return employeeHubSupplierInstance.post("/supplier/graphql",
            {query});
    },
    createSupplierOnboardRequest(supplierOnboardData, draft) {
        let query =
            `mutation createSupplierOnBoardRequest($supplierData: SupplierOnBoardRequestInput!){
              createSupplierOnBoardRequest(draft: ${draft}, request: $supplierData) {
                id
                viewCaseUrl
                caseNumber
              }
            }
        `;

        const variables = {supplierData: supplierOnboardData};
        return employeeHubSupplierInstance.post("/supplier/graphql",
            {
                query,
                variables
            });
    },
    getPOSupplierDetailsById(id, formType) {
        let query = ` query{
                        fetchWebformDetail(id: "${id}", request: {
                            formType: "${formType}"                            
                        }) {
                            webformResponse{
                                invoiceDetail{
                                    supplierName
                                    supplierNameContinued
                                    taxAmount
                                    paymentAmount
                                    currency
                                    poNumber
                                    companyCode
                                    supplierNumber
                                    requesterEmail
                                    formType                                    
                                }
                                bankDetails {
                                    accountHolderName
                                    bankAccount
                                    bankNumber
                                    bankName
                                    bankSwift                                    
                                    country                                   
                                    iban                                                                       
                              }                          
                        }
                    }
                }`
        return employeeHubSupplierInstance.post(
            "/supplier/graphql", {
                query
            });
    },
    submitPurchaseOrderFormData(formData, draft) {
        let isDraft = draft ? `draft:${draft} ,` : "";
        let query =
            `mutation submitPurchaseOrder($formData: PurchaseOrderRequest!){
          submitPurchaseOrder(${isDraft} poRequest: $formData) {
             webformResponse {
              invoiceDetail {
                paymentDescription
                paymentDueDate
                supplierName
                formType
                formReferenceNumber
                requesterEmail
              }
              returnMessages {
                messageId
                message
                messageType
                messageNumber
              }
            }
          }
        }
    `;

        const variables = {formData: formData};
        return employeeHubSupplierInstance.post("/supplier/graphql",
            {
                query,
                variables
            });
    },
    submitNonPOBasedFormData(formData, draft) {
        let isDraft = draft ? `draft:${draft} ,` : "";
        let query =
            `mutation submitNonPurchaseOrder($formData: NonPORequest!){
              submitNonPurchaseOrder(${isDraft} nonPORequest: $formData) {
                 webformResponse {
                  invoiceDetail {
                    paymentDescription
                    paymentDueDate
                    supplierName
                    formType
                    formReferenceNumber
                    requesterEmail
                  }
                  returnMessages {
                    messageId
                    message
                    messageType
                    messageNumber
                  }
                }
              }
            }
        `;


        const variables = {formData: formData};
        return employeeHubSupplierInstance.post("/supplier/graphql",
            {
                query,
                variables
            });
    },
    submitOneTimeSupplierPaymentFormData(formData, draft) {
        let isDraft = draft ? `draft:${draft} ,` : "";
        let query =
            `mutation submitOnetimePayment($formData: OnetimeSupplierRequest!){
              submitOnetimePayment(${isDraft} otvRequest: $formData) {
                webformResponse {
                  invoiceDetail {
                    paymentDescription
                    paymentDueDate
                    supplierName
                    formType
                    formReferenceNumber
                    requesterEmail
                  }
                  returnMessages {
                    messageId
                    message
                    messageType
                    messageNumber
                  }
                }
              }
            }
        `;

        const variables = {formData: formData};
        return employeeHubSupplierInstance.post("/supplier/graphql",
            {
                query,
                variables
            });
    },

    submitAdvancePOPaymentFormData(formData) {
        let query =
            `mutation submitAdvancePayment($formData: AdvancePORequest!){
              submitAdvancePayment(advPORequest: $formData) {
                webformResponse {
                  invoiceDetail {
                    paymentDescription
                    paymentDueDate
                    supplierName
                    formType
                    formReferenceNumber
                    requesterEmail
                  }
                  returnMessages {
                    messageId
                    message
                    messageType
                    messageNumber
                  }
                }
              }
            }
        `;

        const variables = {formData: formData};
        return employeeHubSupplierInstance.post("/supplier/graphql",
            {
                query,
                variables
            });
    },

    submitInvoiceSubmissionData(formData) {

        let query =
            `mutation submitInvoicePdf($formData: PDFInvoice!){
            submitInvoicePdf(invoiceRequest: $formData) {
              invoiceResponse {
                invoiceChannel
                companyCode
                invoiceType
                requesterEmail
                returnMessage {
                  messageId
                  messageNumber
                  messageType
                  message
                }
              }
            }
          }`;

        const variables = {formData: formData};
        return employeeHubSupplierInstance.post("/supplier/graphql",
            {
                query,
                variables
            });
    },

    getAppdata(alias) {
        const solutionsQuery = `solutions {
                              name
                              pageType
                              targets {
                                id
                                linkName
                                linkValue
                                openLinkInNewTab
                                description
                                name
                                searchTags
                              }
                            }`;
        const query = `
        query{
                 getGuidedPlatformAppData(alias:"${alias}"){
                    alias
                    name
                    description
                    showBreadcrumb
                    enableEnterpriseSearch
                    enterpriseSearchQuery
                    enterpriseSearchResultsLength
                    solutionFooterTemplate{
                      solutionFooterValues{
                        linkName
                        linkValue
                        linkPrefix
                        linkSuffix
                      }
                    }
                    supportList {
                      title
                      value
                    }
                    categories {
                      id
                      name
                      image    
                      imageType
                      searchTags  
                      categoryMetaData {
                        childrenPageType 
                        title
                      }
                      description
                      childCategories {
                        id
                        name
                        searchTags
                        parentCategoryId
                        categoryMetaData {
                          title
                        }${solutionsQuery}
                        description
                        childCategories {
                          id
                          name
                          searchTags
                          parentCategoryId
                          categoryMetaData {
                            title
                          }${solutionsQuery}                         
                          description
                          childCategories {
                            id
                            name
                            searchTags
                            parentCategoryId
                            categoryMetaData {
                              title
                            }
                            description
                            ${solutionsQuery}
                          }
                        }
                      }
                    }
               }
           }`
        return employeeHubGuidesInstance.post(
            "/guides/graphql", {
                query
            });
    },

    getInvoices(dateRange, userDetails) {
        let fyParams = `fromDate : "${dateRange.fromDate}", toDate : "${dateRange.toDate}")`
        let invoicesParams = userDetails ? `(userId : "${userDetails}" , ${fyParams}` : `(${fyParams}`
        let query =
            `{
              fetchAllInvoices ${invoicesParams}  {
                poInvoiceResponse {
			        invoices {
                      docId
                      docType
                      requesterId
                      companyCode
                      companyCodeText
                      channelId
                      creditMemo
                      currency
                      expenseType
                      inquiryEmail
                      supplierName
                      supplierNumber
                      invoiceStatus
                      invoiceAmount
                      invoiceDate
                      paymentDate
                      paymentDescription
                      poNumber
                      poStatus  
                      paymentDueDate
                      paymentTermDesc
                      invoiceNumber
                      paymentMethodDesc
                      paymentTermDesc
                      rejectionComments
                      multiplePOCount
                      submissionDate
                      purchaseOrders {
                        poNumber
                        requestedBy 
                        createdBy 
                        poAdditionalData {
                            poNumber
                            costCenterOwner
                            costCenterFbp
                        }
                      }
                    }
                }
                  trackSubmittedInvoice {
			        invoiceRefNumber
			        supplierNumber
			        attachedFileName
			        formType
			        status
			        supplierName
			        companyCode
			        creationDateTime
		          }
               }
            }`

        return employeeHubSupplierInstance.post("/supplier/graphql",
            {query});
    },
    getDirectReportsById(userId) {
        let query = '/v1/team?userName=' + userId
        return ehUserManagementInstance.get(query)
    },
    getPurchaseOrders(dateRange, userDetails) {
        let fyParams = `fromDate : "${dateRange.fromDate}", toDate : "${dateRange.toDate}")`
        let purchaseOrderParams = userDetails ? `(userId : "${userDetails}" , ${fyParams}` : `(${fyParams}`
        let query =
            `{
                fetchAllPurchaseOrders ${purchaseOrderParams} {
                    poAdditionalData {
                        lineItem
                        costCenter
                        costCenterOwner
                        costCenterFbp
                        glAccount
                        allocatedAmount
                        invoicedAmount
                        unutilizedAmount
                        invoiceCurrency   
                      }
                      companyCode
                      companyCodeText
                      docDate
                      netValue
                      netValueInUsd
                      poCurrency
                      poNumber
                      remainingValue
                      remainingValueInUsd
                      requestedBy
                      requisitionNumber
                      status
                      supplierName
                      supplierNumber
                      createdBy 
                }
            }`
        return employeeHubSupplierInstance.post("/supplier/graphql",
            {query});
    },
    getUserInfo(userID) {
        return employeeHubInstance.get("/usermanagement/v1/user?userName=" + userID);
    },
    getPresignedUrl(objectKey, isDownloadRequest) {
        let query =
            `query{
        fetchAttachmentPreSignedUrl(objectKey: "${objectKey}",isDownloadRequest: ${isDownloadRequest}){
          preSignedUrl
        }
  }`;
        return employeeHubSupplierInstance.post("/supplier/graphql",
            {query});
    },
    checkFileUploadStatus(fileName) {
        let query =
            `{ fetchAttachmentUploadStatusById(fileId: "${fileName}") {
                    encryptedFile
                    unSupportedFile
                }
            }`;

        return employeeHubSupplierInstance.post("/supplier/graphql",
            {query});
    },
    uploadApp(file, presignedUrl) {
        // We want to send this PUT without any of our own headers
        var instance = axios.create({
            // Before we send the message, remove our own Authorization header
            transformRequest: [(data, headers) => {
                delete headers.Authorization
                return data;
            }],
            // In order to ensure firefox doesn't complain about no type being returned,
            // we need to set this `response-content-type` (even if we just ignore the response)
            responseType: "text"
        });
        return instance.put(
            presignedUrl,
            file,
            {
                headers: {
                    "Accept": "*/*",
                    "Content-Type": file.type
                }
            }
        );
    },

    getFile(presignedUrl,type){
      var instance = axios.create({
            // Before we send the message, remove our own Authorization header
            transformRequest: [(data, headers) => {
                delete headers.Authorization
                return data;
            }],
            // In order to ensure firefox doesn't complain about no type being returned,
            // we need to set this `response-content-type` (even if we just ignore the response)
            responseType: "blob"
        });
        return instance.get(
            presignedUrl,
            {
                headers: {
                    "Content-Type": type
                }
            }
        );
    },

    closeSupplierOnBoardRequestById(id, reason) {
        let url = '/api/aueis/helphub_tickets/' + store.getters.currentUser.userName + '/sc_req_item/' + id

        //resolved incomplete state shall be shown as 'Cancelled' under 'Completed requests' on Dashboard UI
        let resolved_incomplete_state = CONSTANTS.SERVICE_NOW_CASE_STATUS_MAP.RESOLVED_INCOMPLETE_STATE

        let body = `{
            "fieldArray": [
            {
                "fieldName": "state",
                "fieldValue": "${resolved_incomplete_state}"
            },
            {
                "fieldName": "close_notes",
                "fieldValue": "${reason}"
            }
            ]
        }`

        return serviceNowAxiosInstance.put(url, body)

    },
    getAutocompleteSupplier(searchString, validateSupplier) {
        let validateSupplierQuery = `^u_vendor_parent=${encodeURIComponent(searchString)}`
        let supplierQuery = `^u_vendor_parentLIKE${encodeURIComponent(searchString)}`
        let query = validateSupplier ? validateSupplierQuery : supplierQuery
        let url = CONSTANTS.CORE_COMPANY_API.BASE_QUERY_AUTOCOMPLETE  + query + CONSTANTS.CORE_COMPANY_API.SYS_PARAMS
        return serviceNowAxiosInstance.get(url)
    },
    getResellerFromCoreCompanyTable(){
        let resellerQuery = `u_vendor_idISNOTEMPTY^u_numberNOT LIKEvm^u_supplier_sourceINexternal portal,ivy vendor,sap^u_technology_reseller=true^nameNOT LIKE**`
        let url = CONSTANTS.CORE_COMPANY_API.ONBOARDING_STATUS_BASE_QUERY + resellerQuery + CONSTANTS.CORE_COMPANY_API.SYS_PARAMS
        return serviceNowAxiosInstance.get(url)
    },
    getCoreCompanyStatus(RITMList) {
        let url = CONSTANTS.CORE_COMPANY_API.ONBOARDING_STATUS_BASE_QUERY + `${encodeURIComponent(RITMList)}` + CONSTANTS.CORE_COMPANY_API.SYS_PARAMS
        return serviceNowAxiosInstance.get(url)
    },
    submitExceptionSubmissionRequest(formData) {
        let url = "";
        url = EXCEPTION_SUBMISSION_CONSTANTS.SUBMISSION_BASE_QUERY.API + EXCEPTION_SUBMISSION_CONSTANTS.SUBMISSION_BASE_QUERY.SYSPARM_FIELDS
        return serviceNowAxiosInstance.post(url, formData)
    },
    submitAttachmentToSnow(file, fileName, sysId) {
        let tableName = "sc_req_item"
        let url = `/api/now/attachment/file?table_name=${tableName}&table_sys_id=${sysId}&file_name=${encodeURIComponent(fileName)}`
        return serviceNowAxiosInstance.post(
            url,
            file,
            {
                headers: {
                    "Accept": "*/*",
                    "Content-Type": file.type
                }
            })
    },
    getApexStatus(RITM) {
      let url = '/api/now/table/u_adsk_vendor_onboarding?sysparm_query=u_request_ritmSTARTSWITH'+RITM+'&sysparm_fields=u_apex_supplier_status&sysparm_limit=1'
      return serviceNowAxiosInstance.get(url)
    },
    updateWatchers(userId, watchers, RITMSysId) {
        let payload = `{
            "fieldArray": [
                {
                    "fieldName": "watch_list",
                    "fieldValue": "${watchers}"
                }
            ]
        }`
        let url = `/api/aueis/helphub_tickets/${userId}/sc_req_item/${RITMSysId}`
        return serviceNowAxiosInstance.put(url, payload)
    },
    getSupplierNameById(supplierId) {
        let url = CONSTANTS.CORE_COMPANY_API.BASE_QUERY + `^u_vendor_id%3D${encodeURIComponent(supplierId)}` + CONSTANTS.CORE_COMPANY_API.SYS_PARAMS
        return serviceNowAxiosInstance.get(url)
    },
    getQuestionnaireData(caseNumber, exitPoint) {
        let searchCriteria = `?sysparm_query=u_request_ritm.number=${caseNumber}`
        let sysParamFieldsArray = []
        if(exitPoint.toLowerCase() === EXCEPTION_SUBMISSION_CONSTANTS.EXIT_POINT.toLowerCase()) {
            sysParamFieldsArray = QUESTIONNAIRE_MAP.EXCEPTION_SUBMISSION_REQUEST_FIELDS.map(values => values.fieldName)
        } else
            sysParamFieldsArray = QUESTIONNAIRE_MAP.ONE_INTAKE_FIELDS.map(values => values.fieldName)
        let url = CONSTANTS.QUESTIONNAIRE_DATA + searchCriteria + '&sysparm_fields=' + sysParamFieldsArray.join(",")+",u_service_product"  //EXPAPORTAL-72 changes to not display Product Name if it generated by backend using supplier Name
        return serviceNowAxiosInstance.get(url)
    },
    getAgentCaseStatus(caseNumber) {
        let searchCriteria = `&sysparm_query=parent.number=${caseNumber}`
        let url = CONSTANTS.AGENT_STATUS_API_QUERY + searchCriteria
        return serviceNowAxiosInstance.get(url)
    },
    getParentCaseData(caseNumber) {
        let searchCriteria = `&sysparm_query=number=${caseNumber}`
        let url = CONSTANTS.PARENT_CASE_STATUS_API_QUERY + searchCriteria
        return serviceNowAxiosInstance.get(url)
    },
    getServiceNowUsers(userIds) {
        let searchCriteria = `&sysparm_query=sys_idIN${userIds}`
        let url = CONSTANTS.SERVICENOW_USERS_QUERY + searchCriteria
        return serviceNowAxiosInstance.get(url)
    },
    getCountryListForSupplierCountry() {
        let url = CONSTANTS.SUPPLIER_COUNTRY_QUERY
        return serviceNowAxiosInstance.get(url)
    },
    sendInformationToAccountsPayable(slackMessage, question) {
        let invoiceADSKRef = slackMessage.docId ? `,{key: "ADSK Reference", value: "${slackMessage.docId}"}` : ""
        let invoiceNumberParam = slackMessage.invoiceNumber ? `,{key: "Invoice Number", value:"${slackMessage.invoiceNumber}"}` : ""
        let query =
            `mutation{
                sendSlackMessage(message : {metaData : [{key : "Company Code" ,value : "${slackMessage.companyCode}"},{key: "PO Number", value: "${slackMessage.poNumber}"} ${invoiceNumberParam} ,{key: "Amount", value: "${slackMessage.netValue}"},{key : "Currency" ,value : "${slackMessage.currency}"} ${invoiceADSKRef}], question: "${question}"}) { 
                    success
                    errorMessage
            }
          }`;
        return employeeHubSupplierInstance.post("/supplier/graphql",
            {query});
    },
    getNONPOAutocompleteSupplierResults(supplierAutoCompleteData) {
        let autoCompleteParams = {}
        autoCompleteParams.supplierNameParam = supplierAutoCompleteData.supplierName && supplierAutoCompleteData.supplierName.length > 0 ? supplierAutoCompleteData.supplierName.substr(0, CONSTANTS.MAXIMUM_CHAR_LENGTH_FOR_AUTOCOMPLETE) : ''
        if (supplierAutoCompleteData.supplierId && supplierAutoCompleteData.supplierId.length > 0 && supplierAutoCompleteData.supplierId.length <= 5) {
            autoCompleteParams.supplierIdParam = supplierAutoCompleteData.supplierId + `*`
        } else if (supplierAutoCompleteData.supplierId && supplierAutoCompleteData.supplierId.length > 5 && supplierAutoCompleteData.supplierId.length <= 6) {
            autoCompleteParams.supplierIdParam = supplierAutoCompleteData.supplierId
        } else autoCompleteParams.supplierIdParam = ''
        autoCompleteParams.companyCodeParam = supplierAutoCompleteData.companyCode && supplierAutoCompleteData.companyCode.length > 0 ? supplierAutoCompleteData.companyCode : ''
        let query =
            `{
                fetchInvoiceDetail(request: {supplierName:"${autoCompleteParams.supplierNameParam}", supplierNumber: "${autoCompleteParams.supplierIdParam}", companyCode: "${autoCompleteParams.companyCodeParam}"}){
                  invoiceResponse{
                    invoiceDetails {
                        supplierNumber
                        companyCode
                        companyCodeText
                        supplierName
                        supplierNameContinued
                    }
                  }
                }
          }`;
        return employeeHubSupplierInstance.post("/supplier/graphql",
            {query});
    },
    getAllAdminDataList(isAdminUserRequired) {
        let requestParams = isAdminUserRequired ? `adminUserRequired : ${isAdminUserRequired}` : 'businessPlaceRequired : true , companyCodeRequired : true , countryKeyRequired : true ,countryStateRequired: true ,currencyRequired : true ,expenseTypeRequired : true, vendorCountryRequired: true';
        let query =
            `{
              fetchAllAdminDataList(dataRequest: {
                ${requestParams}
              }) {
                supplierDataList {
                  adminUserList {
                    emailAddress
                    employeeId
                    firstName
                    lastName
                    windowsId
                  }
                  companyBusinessPlaceList {
                    businessPlace
                    businessPlaceText
                    company
                  }
                  companyCodeList {
                    companyCode
                    companyName
                    countryCode
                    currency
                    otvVendorId
                    vatIdRequired
                  }
                  countryCodeList {
                    countryCode
                    countryName
                  }
                  countryList{
                    countryKey
                    countryName
                  }
                  countryStateList{
                    countryCode
                    countryName
                    region
                    regionName
                    regionRequired
                  }
                  currencyList{
                    currencyKey
                    currencyText
                    decimalPrecision
                  }
                  expenseTypeList{
                    expenseType
                    expenseDescription
                  }
                }
              }
            }`;
        return employeeHubSupplierInstance.post("/supplier/graphql",
            {query});
    },
    getCopyDataFromInvoicesDashboard(id, formType) {
        let query =
            `query{
                            fetchInvoiceDetailById(id: "${id}", request: {
                                formType: "${formType}",                         
                            }) {
                                webformResponse{
                                invoiceDetail {
                                    assignment
                                    autoInputFlag
                                    companyCode
                                    companyCodeText
                                    creditMemo
                                    currency
                                    docHeaderText
                                    docId
                                    expenseType
                                    fileSizeInMb
                                    formReferenceNumber
                                    formType       
                                    invoiceChannel
                                    invoiceDate
                                    invoiceRefNumber
                                    originalInvoiceNumber
                                    paymentAmount
                                    paymentDescription
                                    paymentDueDate
                                    paymentInstruction
                                    poNumber
                                    requesterEmail
                                    shipToLocation
                                    supplierName
                                    supplierNameContinued
                                    supplierNumber
                                    taxAmount
                              }
                              invoiceDetailItems {
                                itemId
                                itemDescription
                                glAccount
                                itemAmount
                                costCenter
                                currency
                                wbs
                              }
                              returnMessages {
                                messageId
                                messageNumber
                                messageType
                                message
                              }                         
                            }
                    }
                }`;
        return employeeHubSupplierInstance.post("/supplier/graphql",
            {query});
    },
    updateSupplierNameSheet(){
      let query =
            `mutation{
              updateSupplierNameSheet{
              isSupplierNameSheetUpdated
            }
          }
        `;
      return employeeHubSupplierInstance.post("/supplier/graphql",
            {query});
    },
    createErrorIncident(errorPayload) {
        let query =
            `mutation createSupplierErrorIncident($errorPayload: ErrorPayload!){
              createSupplierErrorIncident(errorPayload: $errorPayload) {
                isIncidentCreated
              }
            }
        `;

        const variables = {errorPayload: errorPayload};
        return employeeHubSupplierInstance.post("/supplier/graphql",
            {
                query,
                variables
            });
    },

};
export default api;